export const blockIconsDeviceGpsFixed = (
	<span className='material-symbols-outlined'>gps_fixed</span>
);
